import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Location } from '../../domain/models/location.model';
import { ServiceRepository } from '../../domain/repositories/service.repository';
import { LocationMapper } from '../mappers/location.mapper';
import { HttpLocationGateway } from '../gateway/service.gateway';
import { LocationApiDTO } from '../dto/location.api.dto';
import { DrawerMapper } from '@features/service/infrastructure/mappers/drawer.mapper';
import { DrawerApiDTO } from '@features/service/infrastructure/dto/drawer.api.dto';
import { Drawer } from '@features/service/domain/models/drawer.model';
import { WorkerMapper } from '@features/service/infrastructure/mappers/worker.mapper';
import { Worker } from '@features/service/domain/models/worker.model';
import { WorkerApiDTO } from '@features/service/infrastructure/dto/worker.api.dto';
import { ServiceRelationsApiDTO } from '@features/service/infrastructure/dto/relation.api.dto';
import { ServiceRelationsMapper } from '@features/service/infrastructure/mappers/service-relations.mapper';
import { ServiceRelations } from '@features/service/domain/models/service-relations.model';

@Injectable({ providedIn: 'root' })
export class HttpServiceAdapter implements ServiceRepository {
  private readonly httpGateway = inject(HttpLocationGateway);
  private readonly locationMapper = inject(LocationMapper);
  private readonly drawerMapper = inject(DrawerMapper);
  private readonly workerMapper = inject(WorkerMapper);
  private readonly serviceRelationsMapper = inject(ServiceRelationsMapper);

  getLocations(): Observable<Location[]> {
    return this.httpGateway.getLocations().pipe(
      map((dtos: LocationApiDTO[]) => this.locationMapper.fromApiArrayToDomain(dtos))
    );
  }

  getDrawers(): Observable<Drawer[]> {
    return this.httpGateway.getDrawers().pipe(
      map((dtos: DrawerApiDTO[]) => this.drawerMapper.fromApiArrayToDomain(dtos))
    );
  }

  getWorkers(): Observable<Worker[]> {
    return this.httpGateway.getWorkers().pipe(
      map((dtos: WorkerApiDTO[]) => this.workerMapper.fromApiArrayToDomain(dtos))
    );
  }

  getServiceRelations(): Observable<ServiceRelations> {
    return this.httpGateway.getRelations().pipe(
      map((dto: ServiceRelationsApiDTO) => this.serviceRelationsMapper.fromApiToDomain(dto))
    );
  }
}
